import type { Prototype } from "../prototype-types";

export const kristinYehPrototypes: Prototype[] = [
  {
    id: "live-shopping",
    name: "Live Shopping",
    path: "/ky/live-shopping",
    description:
      "A live commerce experience where brands demo products in real-time via video, retailers interact through chat, and purchase seamlessly — inspired by the 'retail meets NPR tiny desk concert' concept.",
    owner: "Kristin",
    createdAt: "2026-03-12",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/806c73dcd5fc7be91c7d1988ef549cbb7f2fdb5f9cb33db5f297f64a575ee862.png",
    creationTool: "claude-code",
  },
];
